module.exports = __webpack_public_path__ + "img/tools_productivity_financial_banner.8aa5196e.jpg";